import React, { useState, useEffect } from "react";

// Import your Security Guard topic components
import GuardIntro from "./GuardIntro";
import GuardPatrolling from "./GuardPatrolling";
import GuardPrinciples from "./GuardPrinciples";
import GuardCommunication from "./GuardCommunication";
import GuardEmergency from "./GuardEmergency";
import GuardHealthSafety from "./GuardHealthSafety";
import GuardLaw from "./GuardLaw";
import GuardCustomer from "./GuardCustomer";

const tabs = [
    { label: "Introduction to Security Guarding", component: <GuardIntro /> },
    { label: "Patrolling & Access Control", component: <GuardPatrolling /> },
    { label: "Principles of Private Security", component: <GuardPrinciples /> },
    { label: "Communication & Reporting", component: <GuardCommunication /> },
    { label: "Emergency Procedures & Fire Safety", component: <GuardEmergency /> },
    { label: "Health & Safety in the Workplace", component: <GuardHealthSafety /> },
    { label: "Law & Legal Responsibilities", component: <GuardLaw /> },
    { label: "Customer Service & Professionalism", component: <GuardCustomer /> },
];

function SecurityGuardDashboard() {
    const [selectedTab, setSelectedTab] = useState(0);
    const [search, setSearch] = useState("");
    const [darkMode, setDarkMode] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const filteredTabs = tabs.filter(tab =>
        typeof tab.label === "string" && tab.label.toLowerCase().includes(search.toLowerCase())
    );

    const bgColor = darkMode ? "#1f1f1f" : "#f4f4f4";
    const textColor = darkMode ? "#f4f4f4" : "#1f1f1f";
    const activeColor = darkMode ? "#4caf50" : "#2e8b57";

    return (
        <div
            style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                height: "100vh",
                fontFamily: "Segoe UI"
            }}
        >
            <div
                style={{
                    width: isMobile ? "100%" : "250px",
                    background: bgColor,
                    padding: "10px",
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: "column",
                    borderBottom: isMobile ? "1px solid #ccc" : "none"
                }}
            >
                <input
                    type="text"
                    placeholder="Search topics..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                        padding: "8px",
                        marginBottom: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc"
                    }}
                />
                <label style={{ color: textColor, marginBottom: "10px" }}>
                    <input
                        type="checkbox"
                        checked={darkMode}
                        onChange={() => setDarkMode(!darkMode)}
                        style={{ marginRight: "8px" }}
                    />
                    Dark Mode
                </label>
                {filteredTabs.map((tab, index) => (
                    <div
                        key={index}
                        onClick={() => setSelectedTab(tabs.indexOf(tab))}
                        style={{
                            padding: "12px",
                            marginBottom: "4px",
                            cursor: "pointer",
                            background: tabs.indexOf(tab) === selectedTab ? activeColor : "transparent",
                            color: tabs.indexOf(tab) === selectedTab ? "#fff" : textColor,
                            borderRadius: "6px",
                            fontWeight: tabs.indexOf(tab) === selectedTab ? "bold" : "normal"
                        }}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
            <div
                style={{
                    flex: 1,
                    padding: "20px",
                    overflowY: "auto",
                    background: darkMode ? "#121212" : "#fff",
                    color: textColor
                }}
            >
                {tabs[selectedTab]?.component || <p>No topic selected.</p>}
            </div>
        </div>
    );
}

export default SecurityGuardDashboard;
